module.exports = __webpack_public_path__ + "ronishr.png?8961a231c763f18daf8bc85ae86f0df4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ronishr.png
// module id = 1005
// module chunks = 2